// Generated by ReScript, PLEASE EDIT WITH CARE

import FooterViewCmpTsx from "./FooterViewCmp.tsx";

var make = FooterViewCmpTsx;

export {
  make ,
}
/* make Not a pure module */
